<template>
  <a-spin :spinning="formOption.busy">

    <a-form
        :form="form"
        :label-col="{ span: 12 }"
        :wrapper-col="{ span: 12 }"
    >

      <div class="form_title">创建海报</div>
      <div style="display: flex">
        <div class="bg" id="poster">
          <img :src="api.temp.FILE_PATH + posterBackgroundImg" alt="" ref="imgHeight" class="bg-img">
          <VueDragResize
              v-if="isHeadImg" ref="VueDragResize"
              :isActive="true" :w="hd.width" :h="hd.height" :x="hd.xaxis" :y="hd.yaxis" :parentW="375"
              :parentH=parentH
              :parentLimitation="true"
              @resizing="resize" @dragging="resize"
          >
            <a-avatar :src="require('@/assets/img/moren.png')" class="hd"/>
          </VueDragResize>
          <VueDragResize
              v-if="isName" ref="VueDragResize1" :isActive="true" :w="name.width" :h="name.height"
              :x="name.xaxis"
              :y="name.yaxis"
              :parentW="375"
              :parentH=parentH
              :parentLimitation="true"
              @resizing="resize2" @dragging="resize2"
          >
            <div :style="{color: sizeColor,fontSize: staffNameSize + 'px'}" class="name">员工昵称</div>
          </VueDragResize>
          <VueDragResize
              v-if="isQrcode"
              ref="VueDragResize2" :isActive="true" :w="ewm.width" :h="ewm.height" :x="ewm.xaxis"
              :y="ewm.yaxis" :parentW="375"
              :parentH=parentH
              :parentLimitation="true"
              @resizing="resize1" @dragging="resize1"
          >
            <img :src="require('@/assets/img/ewm.jpg')" alt="" style="width: 100%">
          </VueDragResize>
        </div>
        <div class="form">
<!--          <div class="item" style="margin-bottom: 16px"><span>*</span> 海报标题:-->
<!--            <a-input v-model="title" style="width: 500px;margin-left: 24px"></a-input>-->
<!--          </div>-->

          <a-spin :spinning="formOption.busy">
            <a-form :form="form"
                    :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 12 }"
            >
              <a-form-item label="海报标题">
                <a-input v-decorator="['title', rules.title]" :maxLength="20"
                         placeholder="请输入海报标题"/>
              </a-form-item>
              <a-row :gutter="24">
                <a-form-item label="分类">
                  <a-tree-select
                      v-decorator="['carTypeId',rules.carTypeId]"
                      allow-clear
                      :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
                      placeholder="请选择分类"
                      :treeData="treeData"
                      :replaceFields="{children:'children', title:'codeName', key:'codeId', value: 'codeId' }"
                  >
                  </a-tree-select>
                </a-form-item>

              </a-row>
            </a-form>
          </a-spin>
          <div class="item"><span>*</span> 上传海报背景图 :
            <uploader
                :num="1" v-model="posterBackgroundImg" :accept="'image/*'"
                :url="api.temp.UPLOAD_PATH"
            ></uploader>
            只能上传jpg、jpeg、png文件，建议尺寸：750px*1280px，不超过5M
          </div>
          <div class="keys">
            <p>展示字段</p>
            <ul>
              <li>员工二维码
                <a-switch v-model="isQrcode"/>
              </li>
              <li>员工头像
                <a-switch v-model="isHeadImg"/>
              </li>
              <li>员工昵称
                <a-switch v-model="isName"/>
              </li>
              <li>昵称颜色
                <colorPicker v-model="sizeColor" style="border: 1px solid #000"/>
              </li>
              <li>
                文字大小
                <a-radio-group v-model="staffNameSize">
                  <a-radio-button :value="16">
                    小
                  </a-radio-button>
                  <a-radio-button :value="20">
                    中
                  </a-radio-button>
                  <a-radio-button :value="24">
                    大
                  </a-radio-button>
                </a-radio-group>
              </li>
            </ul>
          </div>
          <div>
            海报上的展示字段可拖动调整位置，点击后拖动边框调整大小
          </div>
        </div>
      </div>
    </a-form>
    <a-space class="a-form-btn-box">
      <a-button @click="close()">取消</a-button>
      <a-button type="primary" @click="_save(false)">提交</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import Vue from 'vue'
import VueDragResize from 'vue-drag-resize'
import vcolorpicker from 'vcolorpicker'

Vue.use(VueDragResize)
Vue.use(vcolorpicker)
import {formMixin, XEUtils} from '@/utils/common/FormBase'
import {dataApi} from '@/services/market/spreadPoster'
import {formatter as fmt} from "@/utils/form-formatter";

/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {
  }
}


/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    carTypeId: {
      rules: [{required: true, message: "请选择分类"}]
    },
    title: {
      rules: [{required: true, message: "请输入海报标题"}]
    },
  };
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId)
  console.log(entity);
  this.posterBackgroundImg = entity.data.posterBackgroundImg
  // this.title = entity.data.title
  this.staffNameSize = entity.data.staffNameSize
  this.sizeColor = entity.data.sizeColor
  this.imgWidth = entity.data.imgWidth
  this.imgHeight = entity.data.imgHeight
  this.isQrcode = entity.data.isQrcode === 1
  this.isName = entity.data.isName === 1
  this.isHeadImg = entity.data.isHeadImg === 1
  return fmt.formatFormLoad(entity);
}

/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  entities.posterId = vm.rowId || 0
  // if (!vm.title) {
  //   this.$message.error('请输入海报标题')
  // } else
    if (!vm.posterBackgroundImg) {
    this.$message.error('请上传海报背景图')
  }

  // entities.title = vm.title
  entities.isQrcode = vm.isQrcode ? 1 : 0
  entities.isName = vm.isName ? 1 : 0
  entities.isHeadImg = vm.isHeadImg ? 1 : 0
  entities.staffNameSize = vm.staffNameSize
  entities.imgHeight = vm.imgHeight
  entities.imgWidth = vm.imgWidth || 375
  entities.sizeColor = vm.sizeColor
  entities.posterBackgroundImg = vm.posterBackgroundImg
  entities.layoutList = [vm.hd, vm.name, vm.ewm]
  await dataApi.saveFormDetail(entities)
}

/**
 * 加载基础数据
 */
async function loadBaseData() {
  // 新增功能 数结构选择分类 sxx 7-19
  let labelRuleData = await dataApi.getPosterTree();
  // 新增分类禁用 仅最后一级可选
  labelRuleData.data.forEach(item=>{
    item.disabled = true
  })

  let treeData = XEUtils.toArrayTree(labelRuleData.data, {
    key: 'codeId',
    parentKey: 'parentId',
    children: 'children'
  });

  // 新增分类禁用 仅最后一级可选
  treeData.forEach(item=>{
    if(item.children.length){
      item.children.forEach(e=>{
        if(e.children.length){
          e.children.forEach(x=>{
            x.disabled = false
          })
        }
      })
    }
  })

  this.treeData = treeData;
}

/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {VueDragResize},
  props: ['layoutList'],
  data() {
    return {
      treeData: [],//分类数结构数据
      parentH: 667,
      hd: {
        width: 70,
        height: 70,
        yaxis: 16,
        xaxis: 16,
        name: 'head'
      },
      name: {
        name: 'name',
        width: 100,
        height: 50,
        yaxis: 20,
        xaxis: 87
      },
      ewm: {
        width: 100,
        height: 100,
        yaxis: 500,
        xaxis: 237,
        name: 'ewm'
      },
      posterBackgroundImg: '',
      imgHeight: 667,
      imgWidth: 375,
      sizeColor: '#ff0000',
      staffNameSize: 16,
      // title: '',
      isQrcode: true,
      isName: true,
      isHeadImg: true
    }
  },
  created() {
    // parentH
    if(this.layoutList){
      this.hd = this.layoutList.find(item => item.name === 'head')
      this.name = this.layoutList.find(item => item.name === 'name')
      this.ewm = this.layoutList.find(item => item.name === 'ewm')
    }

  },
  watch: {
    posterBackgroundImg: {
      handler(newVal, oldVal) {
        const vm = this
        console.log(`Dog changed: ${newVal}`)
        console.log(`Old changed: ${oldVal}`)
        if (newVal) {
          setTimeout(() => {
            vm.$nextTick(() => {
              this.parentH = this.$refs.imgHeight.clientHeight && this.$refs.imgHeight.clientHeight > 667 ? this.$refs.imgHeight.clientHeight : 667
              this.imgHeight = this.parentH
              console.log('this.parentH', this.parentH)
            })
          }, 1200)
        } else {
          console.log('图片高度获取错误')
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getRulesTemplate,
    loadEntity,
    save,
    loadBaseData,
    newEntity,
    resize(newRect) {
      this.hd.width = newRect.width
      this.hd.height = newRect.height
      this.hd.yaxis = newRect.top
      this.hd.xaxis = newRect.left
    },
    resize1(newRect) {
      this.ewm.width = newRect.width
      this.ewm.height = newRect.height
      this.ewm.yaxis = newRect.top
      this.ewm.xaxis = newRect.left
    },
    resize2(newRect) {
      this.name.width = newRect.width
      this.name.height = newRect.height
      this.name.yaxis = newRect.top
      this.name.xaxis = newRect.left
    },
    lastStep() {
      this.$emit('lastStep')
    }
  }
}
</script>
<style lang="less" scoped>
.bg {
  position: relative;
  width: 375px;
  height: 667px;
  border: 1px solid #000;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  .bg-img {
    display: block;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.hd {
  width: 100%;
  height: 100%;
}

.name {
  font-size: 18px;
  font-weight: bold;
}

.form {
  flex: 1;
  margin-left: 24px;

  .item {
    color: #333;

    span {
      display: inline-block;
      margin-right: 4px;
      color: #f5222d;
      font-size: 14px;
      font-family: SimSun, sans-serif;
      line-height: 1;
      content: '*';
    }
  }
  /deep/ .file_list .file_list_item{
    margin-left: 107px;
    margin-top: -10px;
  }
  /deep/ .ant-upload.ant-upload-select-picture-card{
    margin-left: 107px;
    margin-top: 10px;
  }

  .keys {
    display: flex;
    margin: 16px 0;

    li {
      margin-bottom: 12px;
    }
  }
}

/deep/ .m-colorPicker {
  top: 3px
}

.text {
  text-align: center;
  position: absolute;
  width: 100%;
}

/deep/ .m-colorPicker .box.open {
  z-index: 10 !important;
}
</style>
